/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons/index.js";
import {
  schedulesInternalTxnReject,
  updateScheduleDetailData,
} from "../../../../redux/features/scheduleInternalTxn/index.js";
import { toast_position } from "../../../../redux/features/Settings/Authorization/index.js";
import TEXT from "../../../../utils/globalText";
import SmallPopupWithInput from "../../CommonSmallPopupWithInput";
import CommonToast from "../../CommonToast/index.jsx";
import UniversalRefreshToast from "../../UniversalRefreshToast/index.jsx";
import { GlobalConfiguration } from "../../../../utils/configurationProvider.js";

const InternalScheduleTxnDeclinePopup = ({
  allTxnData,
  updateAllTxn,
  handleClose,
  txnId,
  internalDetail,
  flow = "",
  type = "",
  toastType,
}) => {
  const services = useSelector((state) => state.refreshToken.services);
  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const isSubmittingRef = useRef(false);

  const [declineReason, setDeclineReason] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [inputDisabled, setInputDisabled] = useState(false);

  const handleInputChange = (event) => {
    let value = event.target.value;

    // 1. Allow only alphanumeric + space
    value = value.replace(/[^a-zA-Z0-9\s]/g, "");

    // 2. Remove leading spaces
    value = value.replace(/^\s+/, "");

    // 3. Allow only one space between words
    value = value.replace(/\s{2,}/g, " ");

    // 4. Limit to 150 characters
    value = value.slice(0, 150);

    setDeclineReason(value);
  };

  const handleTxnMultiRejecting = () => {
    setTimeout(() => {
      toast.dismiss();
    }, 2000);
  };

  const finalize = () => {
    setShowLoader(false);
    setInputDisabled(false);
    setDeclineReason("");
    handleClose();
  };

  const handleReject = async (id, reason) => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    try {
      if (
        services?.find(
          (service) => service === "IAScheduledTxn" || service === "Admin",
        ) !== undefined
      ) {
        // Token Check
        if (!sessionStorage.getItem("q2p_token")) {
          return;
        }

        setShowLoader(true);
        setInputDisabled(true);

        UniversalRefreshToast(toastType);
        handleTxnMultiRejecting();

        const result = await dispatch(
          schedulesInternalTxnReject({
            type: flow === "multiApproval" ? "multiReject" : "",
            id,
            reason: reason,
            services,
            Navigate,
          }),
        );
        const payload = result?.payload;

        // single approval

        if (!internalDetail) {
          const updatedData = allTxnData.map((item) => {
            if (item.txn_id !== id) return item;

            const tx = payload?.transactions?.[0];
            let lifecycleStatus;
            let errorMessage = "";

            // lifecycle status logic
            if (payload?.status === true) {
              lifecycleStatus =
                tx?.lifecycle_status === "rejected"
                  ? "rejected"
                  : tx?.lifecycle_status === "pending"
                    ? "pendingOne"
                    : item?.lifecycle_status;
            }

            // error message handling
            if (payload?.errors?.base?.[0]?.errors) {
              const errors = payload.errors.base[0].errors;
              errorMessage = errors[0];

              errors.forEach((msg) => {
                if (payload?.status === false) {
                  CommonToast({
                    text: msg,
                    toast_position,
                    icon: ICONS?.INFO_FILLED,
                    variant: "var(--error)",
                  });
                }
              });
            } else if (payload?.errors?.base?.[0]) {
              errorMessage = payload.errors.base[0];
            }

            return {
              ...item,
              lifecycle_status:
                item.lifecycle_status === "pending" && payload?.status === true
                  ? lifecycleStatus
                  : item.lifecycle_status,
              rejected: true,
              rejection_reason: reason,
              error: payload?.status === false ? "true" : "false",
              message: payload?.status === false ? errorMessage : "",
            };
          });

          updateAllTxn(updatedData);
        }
        if (payload?.status) {
          let data = structuredClone(payload);
          data.transaction = payload?.transactions;
          delete data?.transactions;

          dispatch(updateScheduleDetailData(data));
        }

        // wait for loader animation
        await new Promise((resolve) => setTimeout(resolve, 2000));

        if (payload?.status === 500) {
          CommonToast({
            text: payload?.error,
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
          return finalize();
        }

        if (payload?.errors?.user_unauthorized?.[0]) {
          Navigate("/feature_not_assigned", {
            state: { unavailableService: "IAScheduledTxn, Admin" },
          });
          return finalize();
        }

        // MULTI approval flow
        if (flow === "multiApproval") {
          if (payload?.status === false) {
            Navigate(
              "/internal_transaction_dashboard/schedule_multi_approval/schedules_multi_approval/schedules_multi_transaction_error",
            );
          } else {
            CommonToast({
              text: "Schedule rejected successfully.",
              icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
              variant: "var(--success)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text-primary)",
                enabledBgColor: "var(--primary-bg)",
              },
            });
            Navigate(
              "/internal_transaction_dashboard/schedule_multi_approval/schedules_multi_approval/schedules_multi_transaction_reject",
            );
          }
          return finalize();
        }

        // SINGLE approval flow

        // toast results
        if (payload?.status === 500) {
          CommonToast({
            text: payload?.error,
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
          return finalize();
        }

        if (payload?.status === true) {
          CommonToast({
            text: "Schedule rejected successfully.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }

        finalize();
      } else {
        Navigate("/feature_not_assigned", {
          state: {
            unavailableService: "IAScheduledTxn, Admin",
          },
        });
      }
    } finally {
      isSubmittingRef.current = false;
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      const emojiRegex =
        /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
      if (emojiRegex.test(event.key)) {
        event.preventDefault();
        return;
      }

      if (event.key === "Enter") {
        event.preventDefault();
        event.stopPropagation();

        if (!inputDisabled && declineReason.trim().length >= 10) {
          handleReject(txnId, declineReason);
        }
      }

      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        event.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [inputDisabled, declineReason, txnId]);

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  return (
    <div className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-fixed-ui bg-PopUp-BackDrop bg-opacity-dark-opacity">
      <SmallPopupWithInput
        headerTitle={TEXT.REJECT_REASON_LABEL}
        headerFontWeight="semibold"
        headerFontColor="text-primary"
        textSize="font-md"
        secondHeaderTitle={TEXT.REJECTION_REASON_PROMPT_SCHEDULE}
        secondHeaderFontWeight="normal"
        secondHeaderFontColor="text-secondary"
        secondHeaderTextSize="font-xs"
        inputPlaceholder={TEXT.REASON_10_150_CHAR}
        inputVariant={computeVariant(declineReason, isFocused)}
        inputOnFocus={(e) => setIsFocused(true)}
        inputOnBlur={(e) => setIsFocused(false)}
        inputBgColor="var(--primary-bg)"
        inputFgColor="var(--text-secondary)"
        inputOnInput={(e) => {
          if (!showLoader) {
            handleInputChange(e);
          }
        }}
        inputValue={declineReason}
        inputFontKind="small"
        inputIsFullWidth={true}
        // End of Input Field Props
        btnOneText={TEXT.CANCEL}
        btnOneHandleFunction={() => {
          if (!showLoader) {
            handleClose();
          }
        }}
        btnOneEnabledBgColor="var(--primary-bg)"
        btnOneOutLineColor="var(--text-primary)"
        btnOneEnabledTextColor="var(--text-primary)"
        btnOneHoverOption="white"
        btnOneIsDisabled={showLoader}
        btnTwoText={TEXT.REJECT}
        btnTwoHandleFunction={() => {
          if (!declineReason || declineReason.length < 10 || showLoader) {
            return;
          }
          handleReject(txnId, declineReason);
        }}
        btnTwoEnabledBgColor="var(--negative-act)"
        btnTwoEnabledTextColor="var(--text-primary)"
        btnTwoIsDisabled={!declineReason || declineReason.length < 10}
        btnTwoDisabledBgColor="var(--text-disabled)"
        btnTwoIsLoaderNeeded={showLoader ? true : false}
        btnTwoIsLoading={showLoader ? true : false}
        btnTwoHoverOption="black"
        btnTwoInActiveVariantNeeded={true}
        typePopup="RejectAllTransactionPopup"
      />
    </div>
  );
};

export default InternalScheduleTxnDeclinePopup;
